export default {
    deleteMessageManyItems:
        'There are currently {{count}} documents tagged "{{name}}". Deleting this tag will remove it from these documents, but the documents won\'t be deleted.',
    deleteMessageNoItem: 'There are currently no documents tagged "{{name}}"',
    deleteMessageOneItem:
        'There are currently 1 document tagged "{{name}}". Deleting this tag will remove it from this document, but the document won\'t be deleted.',
    deleteTag: 'Are you sure you want delete this tag?',
    name: 'Name',
    remove: 'Remove',
    rename: 'Rename',
    renameTag: 'Rename Tag',
    subtitle:
        "Changes to a tag's name here will also be applied to existing instances of that tag on Documents. Tags can be merged by changing one tag's name to the name of another existing tag.",
    subtitleEmpty: 'Add tags to documents to see them here.',
    title: 'Manage Your Tags',
};
